export default "__VITE_ASSET__R4zo0wCf__"